import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { UserStore } from './userStore';
import { UserResponse } from '@/models/core/user';

type UserType = 'student' | 'school' | 'super-admin' | null;

interface AuthState {
  isLoggedIn: boolean;
  userType: UserType;
  currentUser: UserResponse | null;
  // Add this to track hydration
  _hasHydrated: boolean; 

  logout: () => void;
  login: (isLoggedIn: boolean, userType: UserType, currentUser: UserResponse) => void;
  setHasHydrated: (state: boolean) => void;
}

export const AuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      userType: null,
      currentUser: null,
      _hasHydrated: false, // Default to false

      setHasHydrated: (state: boolean) => {
        set({ _hasHydrated: state });
      },

      login: (isLoggedIn, userType, currentUser) => {
        set({
          isLoggedIn,
          userType,
          currentUser,
        });
      },

      logout: () => {
        try {
          set({
            isLoggedIn: false,
            userType: null,
            currentUser: null,
          });
          UserStore.getState().clearProfile();
        } catch (error) {
          console.error('Logout error:', error);
        }
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      // This function runs when the storage is loaded into the store
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);

export const useAuth = () => {
  return AuthStore((state) => ({
    isAuthenticated: state.isLoggedIn,
    isCurrentUser: state.currentUser,
    isHydrated: state._hasHydrated, // Useful for components
    logout: state.logout,
  }));
};